import { createContext } from 'react';

const restaurantContext = createContext();

export default restaurantContext;
